<mat-card class="content-card">
  <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </mat-card-header>

  <h2>{{ getTitle }}</h2>
  <p>
    Creates accounts for users and emails them an invitation to join the bciti+
    platform. Users will receive an email with a link to choose their password.
  </p>
  <input
    type="file"
    class="file-input"
    accept=".csv"
    [multiple]="false"
    (change)="onFileSelectChange($event)"
    #fileUpload
  />
  <label
    #fileDropRef
    appDragAndDrop
    class="dropzone"
    (fileDropped)="onFileDropped($event)"
  >
    {{ fileName || 'No file selected.' }}
    <button
      mat-mini-fab
      color="primary"
      class="upload-btn"
      (click)="fileUpload.click()"
    >
      <mat-icon>attach_file</mat-icon>
    </button>
  </label>

  <mat-card-footer>
    <button mat-raised-button color="" (click)="clearFile()">Clear</button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="loading"
      (click)="submitSelectedFile()"
    >
      <mat-icon>upload</mat-icon>
      &nbsp;Upload file & invite users
    </button>
  </mat-card-footer>
</mat-card>

<mat-card class="file-validation">
  // TODO frontend file validation with csv-parse? (make sure every row has an
  email, fn, ln)
  <h2>File validation</h2>
</mat-card>
